<template>
  <div id="contents">
    <div class="recruit_info" >
      <div class="recruit_info_main">
        <div class="info_list">
          <div @click="close" class="close_icon">
            <img src="../assets/img/common/recruit_2021/close_icon.svg" alt=""/>
          </div>
          <div class="info_list_message">
            <div class="logo">
              <img src="../assets/img/common/recruit_2021/info/recruit_2021_logo.png" alt="人材教育">
            </div>
            <p>当社は若手の「才能」「挑戦」を全面的にバックアップします。<br>マイナビのマイページからエントリーシートの提出をお願いします！</p>
          </div>
          <div class="divisions">
            <p class="divisions_desc"><span class="blue">「映像コンテンツクリエイター」</span>と<spam class="purple">「デジタルビジネスクリエイター」</spam>の2部門で募集します。</p>
            <ul class="divisions_list">
              <li>
                <p class="ttl blue">「映像コンテンツクリエイター」</p>
                <p class="desc">報道情報、ドキュメンタリー、バラエティ、ドラマ、映画、（ABEMA・YouTube等のネットコンテンツ）の<br />企画・制作業務を志望する方は、こちらにエントリーしてください。</p>
              </li>
              <li>
                <p class="ttl purple">「デジタルビジネスクリエイター」</p>
                <p class="desc">YouTube・TikTok等の動画制作をはじめ、インターネットサービスや、デジタルを駆使した新たなコンテンツ展開を<br />仕掛けるビジネスの企画・開発の業務を志望する方は、こちらにエントリーしてください。</p>
              </li>
            </ul>
          </div>
          <!-- <div class="company_briefing_session">
            <p class="title">会社説明会</p>
            <p>オンラインにて説明会を開催します。</p>
            <p class="schedule_ttl">【開催日時】</p>
            <dl class="schedule_list">
              <dt>3月 5日（金）</dt><dd> 16:00～17：30</dd>
              <dt>3月12日（金）</dt><dd> 16:00～17：30</dd>
            </dl>
            <p>マイナビで予約して下さい。当サイトの「ENTRY」でマイナビにリンクします。<br />出席人数に限りがありますので、早めの予約をお願いします。</p>
          </div> -->
          <div class="info_list_title">
            <h4>応募要項</h4>
          </div>
          <p class="caption">応募要項をご確認の上、上部「ENTRY」ボタンからご応募ください。</p>
          <div class="info_item">
            <div class="info_item_title">
              <p>募集職種・⼈員</p>
            </div>
            <div class="info_item_content text_list">
              <p class="text">総合職・10名程度</p>
              <p class="text">映像コンテンツクリエイター ／ <br />報道情報、ドキュメンタリー、バラエティ、ドラマ、映画、（ABEMA・YouTube等のネットコンテンツ）の企画・制作</p>
              <p class="text">デジタルビジネスクリエイター ／ <br />YouTube・TikTok等の動画制作をはじめ、インターネットサービスや、デジタルを駆使した新たなコンテンツ展開を仕掛けるビジネスの企画・開発</p>
              <p class="text">※２部門の中から応募できるのは１つのみです。<br />※総合職としての採用となりますので、上記以外の部署への配属の可能性もあります。</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>応募資格</p>
            </div>
            <div class="info_item_content">
              <p>1995年（平成7年）4月2日以降の出生の方で</p>
              <p>①４年制大学及び大学院を2023年3月卒業見込みの方</p>
              <p>②４年制大学及び大学院を既卒の方</p>
              <p>※長期勤続によるキャリア形成を図るため</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>待遇</p>
            </div>
            <div class="info_item_content">
              <p>月給 235,150円</p>
              <p>※ 固定残業手当52,650円（30時間相当分）を含む</p>
              <p>※ 固定分を超える残業時間については別途残業手当を支給</p>
              <p class="right">※2022年度実施</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>昇給</p>
            </div>
            <div class="info_item_content">
              <p>年1回</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>賞与</p>
            </div>
            <div class="info_item_content">
              <p>年4回（4月、6月、10月、12月）</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>勤務時間</p>
            </div>
            <div class="info_item_content">
              <p>原則として10：00～18：00（職場によりシフト勤務）</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>休日・休暇</p>
            </div>
            <div class="info_item_content">
              <p>完全週休2日制（原則として土・日）</p>
              <p>祝日、夏季・冬季・年末年始休暇、有給休暇、誕生日休暇、永年勤続特別休暇</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>福利厚生</p>
            </div>
            <div class="info_item_content mt_23">
              <p>・各種社会保険完備（テレビ朝日健康保険組合、厚生年金保険、雇用保険、労災保険）</p>
              <p>・通勤費支給</p>
              <p>・育児介護支援制度</p>
              <p>・東京ディズニーリゾート・コーポレートプログラム利用券</p>
              <p>・TOHOシネマズパスポートチケット</p>
              <p>・保養所（東急ハーヴェストクラブ/みやび倶楽部）</p>
              <p>・厚生会マイチョイス</p>
              <p>　1年間に一定のポイントが付与され、レジャー、エンターテイメント鑑賞、スポーツ観戦、</p>
              <p>　習い事、エステなど、自分の好きなことに使える福利厚生プログラムです。</p>
              <p>　（2022年度実績 45,000ポイント付与）</p>
              <p>・クラブ活動補助</p>
              <p>・チケットレストラン加盟店、Uber Eatsの利用による食事補助</p>
              <p>・外部講座の受講</p>
              <p>　人材育成及び定時退社の奨励策として、外部講座の受講費用を会社で負担。</p>
              <p style="margin-bottom: 15px">・ノートPC、iPhone貸与（iPhoneを全従業員に配付）</p>
              <p style="margin-bottom: 15px">※同性パートナーシップ制度を導入。同性パートナーを戸籍上の配偶者と同等に扱います。</p>
              <p class="right">※2022年度実施</p>
            </div>
          </div>
          <div class="info_item">
            <div class="info_item_title">
              <p>問い合わせ先</p>
            </div>
            <div class="info_item_content">
              <p>テレビ朝⽇映像株式会社 ⼈事部 採⽤担当</p>
              <p>saiyo2024@tv-asahipro.co.jp</p>
            </div>
          </div>
          
        </div>
        <!-- <div class="upcoming_events">
          <p class="upcoming_events_title">今後のリクルートイベント</p>
          <p class="upcoming_events_info">※新型コロナウイルス感染症の拡大状況を鑑み、予定を変更しています（３月１０日現在）。</p>
          <div class="upcoming_events_item">
            <div class="upcoming_events_item_date">
              <p>２０２０年２月</p>
            </div>
            <div class="upcoming_events_item_content">
              <p>１DAYインターンシップ（終了）</p>
            </div>
          </div>
          <div class="upcoming_events_item">
            <div class="upcoming_events_item_date">
              <p> ２０２０年２月２１日（金）</p>
            </div>
            <div class="upcoming_events_item_content">
              <p>マスコミ映像就職フェスタ（終了）</p>
            </div>
          </div>
          <div class="upcoming_events_item">
            <div class="upcoming_events_item_date">
              <p>２０２０年３月３日（火）</p>
            </div>
            <div class="upcoming_events_item_content add_info">
              <a href="https://company.tv-asahi.co.jp/saiyo/group/" target="_blank"><img class="company_info_logo" src="../assets/img/common/recruit_2021/tv-asahi_company_info_logo.png" alt="テレビ朝日グループ 合同会社説明会 2021"></a>
              <span class="schedule_info">中止となりました。</span>
            </div>
          </div>
          <div class="upcoming_events_item">
            <div class="upcoming_events_item_date">
              <p>準備中</p>
            </div>
            <div class="upcoming_events_item_content">
              <p>テレビ朝日映像　会社説明会</p>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_info
    &_main
      width: 1000px
      margin: 0 auto
      padding: 0 0 75px 0
      position: relative
    .info_list
      width: 1000px
      margin: 0 auto
      margin-top: 96px
      .close_icon
        position: absolute
        right: 0px
        img
          width: 40px
          height: 40px
      &_message
        padding-top: 81px
        .logo
          width: 821px
          height: 85px
          margin: 0 auto
          img
            width: 100%
        p
          margin: 51px 0 67px 0
          @include recruit_font(16px, 33px, 0.228em)
          color: #fff
          text-align: center
      .divisions
        margin-bottom: 146px
        padding: 53px 0 84px
        background: #fff
        .blue
          color: #3785E0
        .purple
          color: #8B53AF
        &_desc
          margin-bottom: 55px
          @include recruit_font(20px, 1em, 0.1em)
          text-align: center
        &_list
          position: relative
          padding-top: 46px
          &::before
            content: ""
            position: absolute
            top: 0px
            left: 50%
            transform: translate(-50%, 0%)
            width: 810px
            height: 3px
            background: url('../assets/img/common/recruit_2023/pink_dot_line.png') left
            background-size: 11px
          li
            margin-bottom: 67px
            &:last-child
              margin-bottom: 0px
            .ttl
              margin-bottom: 24px
              @include recruit_font(22px, 1em, 0.1em)
              text-align: center
            .desc
              @include recruit_font(14px, 31px, 0.1em)
              text-align: center
      .company_briefing_session
        margin: 0 0 88px 0
        .title
          @include recruit_font(40px, 59px, 7px)
          display: inline-block
          margin: 0 0 27px
          padding: 0 5px 3px 9px
          color: #FF7689
          background-color: #fff
        p
          @include recruit_font(16px, 28px, 2px)
          color: #fff
        .schedule_ttl
          @include recruit_font(22px, 37px, 2px)
          margin: 10px 0 0 -13px
        .schedule_list
          @include recruit_font(16px, 28px, 2px)
          margin: 0 0 11px 0
          color: #fff
          dt
            float: left
          dd
            margin-left: 130px
      &_title
        width: 210px
        background-color: #fff
        h4
          @include recruit_font(40px, 59px, 7px)
          color: #FF7689
          padding: 0 0 0 9px
      .caption
        @include recruit_font(16px, 28px, 3px)
        margin: 27px 0 38px 0
        color: #fff
      .info_item
        margin-top: 14px
        background-color: #fff
        display: flex
        &_title
          width: 329px
          p
            @include recruit_font(20px, 84px, 4px)
            color: #FF7689
            margin: 0 0 0 33px
        &_content
          width: 671px
          padding: 18px 0 18px 0
          display: flex
          flex-wrap: wrap
          align-items: center
          &.text_list
            padding: 11px 0 11px 0
          p
            @include recruit_font(14px, 14px, 2px)
            width: 100%
            &:not(:first-child)
              margin-top: 15px
            &.text
              padding-right: 40px
              @include recruit_font(14px, 2em, 2px)
          .right
            text-align: right
            margin-right: 13px
        .mt_23
          margin-top: 8px
    .upcoming_events
      &_title
        @include recruit_font(24px, 46px, 3px)
        color: #fff
        margin: 48px 0 19px 0
        border-bottom: 4px solid #FFFFFF
      &_info
        @include recruit_font(17px, 34px, 2px)
        margin-bottom: 20px
        padding-left: 7px
        color: red
        display: inline-block
        background-color: #fff
      &_item
        display: flex
        border-bottom: 2px dashed #FFFFFF
        &_date
          @include recruit_font(17px, 53px, 3px)
          color: #fff
          width: 341px
        &_content
          @include recruit_font(17px, 53px, 3px)
          color: #fff
          width: 659px
          position: relative
          a
            cursor: pointer
          .company_info_logo
            width: 386px
            height: 77px
            margin: 14px 0 10px 0 
          .schedule_info
            @include recruit_font(17px, 34px, 2px)
            display: table
            color: red
            background-color: #fff
            padding-left: 4px
          &.add_info
            margin-bottom: 15px

</style>



// WEBPACK FOOTER //
// src/components/recruit_info.vue